<div class="container-fluid fl-wrapper">
    <div class="d-flex justify-content-between align-items-center">
        <h3>Funding Exception</h3>
        <form [formGroup]="inputDateForm" class="mt-4">
            <div class="container-fluid">
                <div class="row g-3" style="position: relative;">
                    <div class="col-12 col-lg-6 col-xl-3">
                        <mat-form-field appearance="outline">
                            <mat-label>Choose a date</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="input_date">
                            <mat-hint>MM/YYYY</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker startView="multi-year"
                                (monthSelected)="setMonthAndYear($event, picker)"
                                panelClass="month-picker"></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div style="height: calc(100% - 200px)">
        <app-custom-table [columnDefs]="columnDefs" [rowData]="fundingExceptions" [hideGlobalFilter]="true"
            [pagination]="true" [paginationPageSize]="50" (cellValueChanged)="onCellValueChanged($event)">
        </app-custom-table>
    </div>
</div>